import type { ConnectionEditState } from "../../viewmodels/board/connections/Connections.types";
import { parseConnectionConfiguration } from "../source-settings/SourceSettingsConfiguration";

interface PlannerBucketReference {
  id?: unknown;
}

interface PlannerConfigurationValidationModel {
  buckets?: PlannerBucketReference[];
  doneBucket?: PlannerBucketReference;
  mode?: string;
}

const normalizeId = (value: unknown): string => String(value ?? "");

export const getPlannerSourceSettingsValidationMessage = (
  editingConnection: ConnectionEditState,
  t: (key: string) => string,
): string => {
  const configuration =
    parseConnectionConfiguration<PlannerConfigurationValidationModel>(
      editingConnection.configuration,
    );
  const isPlanMode = (configuration.mode ?? "plan").toLowerCase() === "plan";
  const doneBucketId = normalizeId(configuration.doneBucket?.id);

  if (!isPlanMode || !doneBucketId) {
    return "";
  }

  const buckets = configuration.buckets ?? [];
  return buckets.some((bucket) => normalizeId(bucket.id) === doneBucketId)
    ? t("board.connections.dialog.sourceSettings.planner.bucketReferenceError")
    : "";
};
